import { useState } from "react";
import Accordion from "src/components/UI/Accordion";
import Breadcrumbs from "src/components/UI/Breadcrumbs";
import Tabs from "@shared/UI/Tabs";
import { QuestionAnswer } from "src/static/instructorPanel";
import {
	createCourseQAs,
	faqSections,
	financesQAs,
	legalQAs,
	platformRulesQAs,
	supportQAs,
} from "src/static/selfSchoolQAs";
import s from "./styles.module.sass";
import { MainPagesLayout } from "../../../containers/MainPagesLayout";

const qasWithId: Record<number, QuestionAnswer[]> = {
	0: createCourseQAs,
	1: platformRulesQAs,
	2: supportQAs,
	3: financesQAs,
	4: legalQAs,
};

const FaqView = () => {
	const [activeTab, setActiveTab] = useState(0);

	const handleChangeTab = (id: number) => {
		setActiveTab(id);
	};

	const renderQuestions = (qas: QuestionAnswer[]) => {
		return qas.map((qa) => {
			return (
				<li key={qa.id} className={s.qa}>
					<Accordion
						variant="outlined"
						titleChildren={<p className={s.accordionTitleLeftSide}>{qa.question}</p>}
					>
						<p>{qa.answer}</p>
					</Accordion>
				</li>
			);
		});
	};

	return (
		<MainPagesLayout>
			<Breadcrumbs
				links={[
					{
						id: 0,
						title: "Главная",
						to: "/",
					},
				]}
				currentPage="Часто задаваемые вопросы"
			/>

			<h1 className={s.title}>Часто задаваемые вопросы</h1>
			<p className={s.faqDescr}>
				Мы собрали список ответов на&nbsp;общие и&nbsp;финансово-юридические вопросы, связанные
				с&nbsp;обучением и&nbsp;преподаванием на&nbsp;платформе Selfschool.
			</p>

			<Tabs
				activeTab={activeTab}
				tabs={faqSections}
				onSelect={(id) => {
					return handleChangeTab(id);
				}}
			/>

			<ul className={s.qas}>
				{activeTab === 0 && <>{renderQuestions(qasWithId[0])}</>}
				{activeTab === 1 && <>{renderQuestions(qasWithId[1])}</>}
				{activeTab === 2 && <>{renderQuestions(qasWithId[2])}</>}
				{activeTab === 3 && <>{renderQuestions(qasWithId[3])}</>}
				{activeTab === 4 && <>{renderQuestions(qasWithId[4])}</>}
			</ul>
		</MainPagesLayout>
	);
};

export default FaqView;
